export const blockIconsImageNavigateBefore = (
	<span className='material-symbols-outlined'>navigate_before</span>
);
